module.exports = __webpack_public_path__ + "media/step3_animation.d87adf03.mp4";